import strs from './strings';
import React, { useCallback, useEffect, useRef, useState } from 'react';
import { Form, useFormik } from "formik";
import { BackButton, Spacer, Spacer10, Spacer100, Spacer25, Spacer5 } from './Utils';
import { Button, Input, TextField } from '@mui/material';
import * as yup from 'yup';
import emailjs from 'emailjs-com';
import { getUser } from './firestore';
import { auth } from './firebase';

const lang = strs.en;
const SERVICE_ID = "service_b0zijlr" 
const TEMPLATE_ID = "template_jusof6x";
const PUBKEY = "O8pM6g3xtCNp1645d";


export default function Contacto() {
	
	const [contactForm, setContactForm] = useState({
		subject: '',
		message: '',
	});
	const [isVisible, setIsVisible] = useState('hidden');
	const [isAlert, setIsAlert] = useState(false);
	const [littlePopupText, setLittlePopupText] = useState(lang.contactFormSubmitted);
	const [submitted, setSubmitted] = useState(false);

	const basicSchema = yup.object().shape({
		subject: yup.string().required(),
		message: yup.string().required(),
	})


	const {values, handleBlur, handleChange, resetForm, touched, errors} = useFormik({
		initialValues: {
			subject: '',
			message: '',
		},
		validationSchema: basicSchema,

	});

	const form = useRef();


	function changeHandler(event) {
		const {name, value} = event.target;
		setContactForm( prevContactForm => ({
			...prevContactForm,
				[name]: value,
		}) )
		handleChange(event);
		console.log('contactForm', contactForm);
	}

	async function submitForm(event) {
		event.preventDefault();
		if (submitted) {
			setLittlePopupText(lang.alreadySubmitted);
			setIsAlert(true);
			setIsVisible('fade-in');
			setTimeout( () => {
				setIsVisible('');
				setTimeout( () => {
					setIsVisible('fade-out');
				}, 3000);
				
			}, 500);
			return;
		};
		setIsVisible('fade-in');

		let name = "";
		let uid = "";
		try {

			const isFormValid = await basicSchema.validate(contactForm, {abortEarly: false});
			if (!isFormValid) throw new yup.ValidationError("Incomplete form");

			setIsAlert(false);
			setLittlePopupText(lang.contactFormSubmitted);
			const uid = auth.currentUser.uid;
			const user = await getUser();
			const basicInfo = user?.basicInfo;
			const name = `${basicInfo?.firstName} ${basicInfo?.middleName} ${basicInfo?.lastname} ${basicInfo?.secondLastName}`;
			const email = user?.email;
			console.log('uid', uid)
			const emailString = `user: ${name}\n\n email: ${email}\n\nuid: ${uid}\n\nsubject: ${contactForm.subject}\n\nmessage: ${contactForm.message}`
			console.log('emailString', emailString);
			console.log('contactForm', contactForm);
			emailjs.send(SERVICE_ID, TEMPLATE_ID, {message: emailString}, PUBKEY)
			setTimeout( () => {
				setIsVisible('');
				setTimeout( () => {
					setIsVisible('fade-out');
				}, 6000);
				
			}, 500);
			resetForm();
			setSubmitted('true');
		}
		catch (error) {
			if (error instanceof yup.ValidationError){
				setLittlePopupText(lang.invalidForm);
			}
			else {
				setLittlePopupText(lang.errorSubmitting);
			}
			setIsAlert(true);
			setIsVisible('fade-in');
			setTimeout( () => {
				setIsVisible('');
				setTimeout( () => {
					setIsVisible('fade-out');
				}, 3000);
				
			}, 500);


		}


	}


	return (
		<div>
			<BackButton />
			<Spacer />
			<h2 className='primary-title'>{lang.contact}</h2>
			<Spacer100 />
			
			<div className='center-flex'>
			<form ref={form} className='animated-div' onSubmit={submitForm}>
				<h3 className='secondary-title'><center>{lang.contactForm}</center></h3>
				<Spacer />
				<p className='p larger-font centered-text'>{lang.contactFormSubheader}</p>
				<Spacer25 />
				{touched.subject && errors.subject ?
				<p className='alert required-text' for='subject'>{lang.required}</p> : <p className='required-text p'>{lang.subject}</p>}
				<Spacer5 />
				<Input 
					id="subject" 
					name="subject"
					label="Subject" 
					variant="outlined" 
					placeholder={lang.subject}
					onChange={changeHandler}
					onBlur={(event) => {handleBlur(event)}}
					className={`form-text-item ${touched.subject && errors.subject ? 'input-error' : ''} min-width-100 no-margin`} 
					value={values.subject}
				/>	
				
				<Spacer25 />

				{touched.message && errors.message ?
				<p className='alert required-text' for='message'>{lang.required}</p> : <p className='required-text p'>{lang.message}</p>}
				<Spacer5 />
				<textarea 
					id="message"
					name="message"
					className='text-area p no-margin' 
					placeholder={lang.message}
					value={values.message}
					onChange={changeHandler}
					onBlur={(event => {handleBlur(event)})}>
				</textarea>
				
				<Spacer />
				
				<div className='grid-column'>
				<Button 
					onClick={submitForm}
					variant="contained" 
					className='grow-and-shrink-slightly' 
					sx={{
						minHeight:  40,
						minWidth: 200,
						borderRadius: 5,
						padding: 2,
						fontSize: 20,
						textTransform: "none",
						fontFamily: "inherit",
						fontWeight: 400,
				}}>
					{lang.submit}
				</Button>
				<p className={`${isVisible} centered-text little-popup ${isAlert ? 'alert' : ''}`}>{littlePopupText}</p>
				</div>


			</form>
			</div>
		</div>
	);
}
